export type NavigationOrigin =
  | 'foryou'
  | 'search'
  | 'chat'
  | 'profile'
  | 'bookings'
  | 'settings'
  | 'creator'
  | 'deeplink'
  | null;

export type NavigationDomain =
  | 'foryou'
  | 'search'
  | 'chat'
  | 'profile'
  | 'settings'
  | 'location'
  | 'booking'
  | 'creator'
  | 'bookingHistory';

export interface NavigationEntry {
  path: string;
  name: string;
  params?: Record<string, any>;
  query?: Record<string, any>;
  state?: Record<string, any>;
  timestamp: number;
  domain: NavigationDomain;
}

export interface ViewStack {
  entries: NavigationEntry[];
  currentIndex: number;
  domain: NavigationDomain;
  origin: NavigationOrigin;
}

export interface BookingContext {
  locationId: string;
  locationName: string;
  roomId?: string;
  roomType?: string;
  checkIn?: string;
  checkOut?: string;
  guests?: number;
}

export interface LocationContext {
  locationId: string;
  fromDomain: NavigationDomain;
  fromConversationId?: string;
  fromMessageId?: string;
}

export interface ChatContext {
  conversationId: string;
  conversationType: 'dm' | 'group';
  participantIds: string[];
}

export const TOP_LEVEL_ROUTES = [
  '/foryou',
  '/search',
  '/chat',
  '/profile',
  '/bookings',
  '/settings'
] as const;

export const TOP_LEVEL_ROUTE_MAP: Record<string, NavigationOrigin> = {
  '/foryou': 'foryou',
  '/search': 'search',
  '/chat': 'chat',
  '/profile': 'profile',
  '/bookings': 'bookings',
  '/settings': 'settings'
};

export const EXIT_ROUTES: Record<NonNullable<NavigationOrigin>, string> = {
  'foryou': '/foryou',
  'search': '/search',
  'chat': '/chat',
  'profile': '/profile',
  'bookings': '/bookings',
  'settings': '/settings',
  'creator': '/profile',
  'deeplink': '/foryou'
};